import { Route, Routes } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import axios from "axios";
import Homepage from "./pages/Homepage";
import Layout from "./Layout/Layout";
import Buildings from "./pages/Buildings";
import AddBuilding from "./pages/AddBuilding";
import BuildingDetails from "./pages/BuildingDetails";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import SignIn from "./pages/auth/SignIn";
import { UserContextProvider } from './contexts/UserContext';
import { TokenExpiryProvider } from './contexts/TokenExpiryManager';
import DecarbonizationActions from './pages/DecarbonizationActions';
import BuildingOptimization from './pages/BuildingOptimization';

let primary = '#5871b7'
let secondary = '#31bebe'
const theme = createTheme({
    palette: {
        primary: { main: primary },
        secondary: { main: secondary },
        gradient: { main: `linear-gradient(270deg, ${primary} 50%, ${secondary} 100%)` }
    },
    typography: {
        fontFamily: ['Poppins', 'Segoe UI', 'Roboto', 'Jura'].join(','),
    }
});

function App() {
    axios.defaults.baseURL = 'https://decarbonization-backend.metabuild.epu.ntua.gr';
    return (
        <TokenExpiryProvider>
            <UserContextProvider>
                <ThemeProvider theme={theme}>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Homepage />} />
                            <Route path="/buildings" element={<Buildings />} />
                            <Route path="/buildings/:id" element={<BuildingDetails />} />
                            <Route path="/buildings/:id/optimization" element={<BuildingOptimization />} />
                            <Route path="/add-building" element={<AddBuilding />} />
                            <Route path="/decarbonization-actions" element={<DecarbonizationActions />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/signin" element={<SignIn />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Layout>
                </ThemeProvider>
            </UserContextProvider>
        </TokenExpiryProvider>
    );
}

export default App;
